import mapValue from "./mapValue";
import Color from "./Color";

var colorWheel;
{
    var instances = [];
    var decimal = 1000;
    function drawFrame(_instance) {
        var name = _instance.name;
        var frameRate = _instance.frameRate;
        var hold = _instance.hold;
        var cycleDuration = _instance.cycleDuration;
        var keyframes = _instance.keyframes;
        var keyframeCount = _instance.keyframeCount;
        var tweenDuration = _instance.tweenDuration;

        var cycleProgress = Date.now() % cycleDuration;
        var tweenProgress = mapValue(cycleProgress % tweenDuration, 0, tweenDuration, 0, 1);
        var keyframeIndex = Math.floor(mapValue(cycleProgress, 0, cycleDuration, 0, keyframeCount * decimal) / decimal);
        var colorFrom = keyframes[keyframeIndex];
        var colorTo = keyframeIndex == keyframeCount - 1 ? keyframes[0] : keyframes[keyframeIndex + 1];
        var colorLerp = hold ? colorFrom.replace("#", "") : Color.lerpColor(colorFrom, colorTo, tweenProgress);

        if (_instance.options.debug) {
            console.log({
                colorLerp: colorLerp,
                cycleDuration: cycleDuration,
                cycleProgress: cycleProgress / cycleDuration,
                frameRate: frameRate,
                keyframes: keyframes,
                keyframeIndex: keyframeIndex,
                tweenProgress: tweenProgress,
            });
        }

        document.documentElement.style.setProperty(name, `#${colorLerp}`);
    }

    colorWheel = class {
        constructor(_name = "--colorWheel", _options) {
            const defaults = {
                keyframes: ["#ff0000", "#00ff00", "#0000ff"],
                cycleDuration: 30000,
                frameRate: 2000,
                hold: false,
                debug: false,
            };
            this.name = _name;
            this.options = Object.assign({}, defaults, _options);
            this.cycleDuration = this.options.cycleDuration;
            this.frameRate = this.options.frameRate;
            this.hold = this.options.hold;
            this.keyframes = this.options.keyframes;
            this.keyframeCount = this.options.keyframes.length;
            this.tweenDuration = this.cycleDuration / this.keyframeCount;

            instances.push(this);
            return this;
        }
    };

    colorWheel.spin = function () {
        instances.forEach(function (_instance) {
            drawFrame(_instance);
            setInterval(function () {
                drawFrame(_instance);
            }, _instance.frameRate);
        });
    };
}

export default colorWheel;
